import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

function DropdownResources(props) {

    // Getting the Array List
    const dropdownList = props.resources.map(x => { return { label: x.name, value: x.id } })
    // Filtering the Array list for any duplicates
    const filtered = Array.from(new Set(dropdownList.map(a => a.label)))
        .map(label => {
            return dropdownList.find(a => a.label === label)
        })
    return (
        <Autocomplete
            freeSolo
            disablePortal
            value={(props.selectedResource !== undefined && props.selectedResource !== null) ? filtered.find(x => x.value === props.selectedResource.id) : props.value}
            onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                    props.action(newValue, event)
                } else if (newValue && newValue.inputValue) {
                    props.action(newValue, event)
                } else {
                    props.action(newValue, event)
                }
            }}
            options={filtered.sort((a, b) => a.label.localeCompare(b.label))}
            renderInput={(params) => <TextField error={props.error} helperText={props.helperText} {...params} InputLabelProps={{ shrink: false }} onChange={(event) => props.action(event)}/>}
        />
    );
}

export default DropdownResources